import { createSelector } from 'reselect';

export const selectGroupsSlice = state => state.groups;
export const selectGroups = createSelector(
  selectGroupsSlice,
  slice => slice.groups
);
export const groupsMeta = createSelector(
  selectGroupsSlice,
  slice => slice.meta
);
export const groupsFilters = createSelector(
  selectGroupsSlice,
  slice => slice.filters
);

export const selectGroup = id => {
  return createSelector(
    selectGroupsSlice,
    slice => slice.groups.filter(group => group.id === id)[0]
  );
};
